import {
  TRecipeAvailability,
  TSummaryAvailabilityRecipe,
} from '@mindfulchefuk/types/recipeAvailabilities'
import { RecipeWithQuantity } from '@mindfulchefuk/features/Recipes/interfaces'
import { transformSummaryAvailabilityToRecipeWithQuantity } from '../dataTransforms/transformRecipeAvailabilitiesToRecipeWithQuantity'

export type TBasketRecipeSummary = {
  image: string
  title: string
  price: number
}

export type TBasketRecipeFullDetails = RecipeWithQuantity & {
  basketDisplayTitle: string
  quantity: number
}

export const getBasketRecipeSummariesFromBasketIDs = ({
  recipeIdsInBasket,
  recipeAvailabilities,
}: {
  recipeIdsInBasket: Record<string, number>
  recipeAvailabilities: TRecipeAvailability<TSummaryAvailabilityRecipe>[]
}): TBasketRecipeSummary[] => {
  return recipeAvailabilities.reduce((recipes, currentAvailability) => {
    const recipeIds = Object.keys(recipeIdsInBasket)

    recipeIds.map((recipeId: string) => {
      const hasMultipleRecipes = recipeIdsInBasket[recipeId] > 1
      if (parseInt(recipeId, 10) === currentAvailability.recipe.id) {
        return recipes.push({
          image: currentAvailability.recipe.image,
          title: hasMultipleRecipes
            ? `${recipeIdsInBasket[recipeId]}x ${currentAvailability.recipe.title}`
            : currentAvailability.recipe.title,
          price:
            recipeIdsInBasket[recipeId] *
            parseInt(currentAvailability.price, 10),
        })
      }

      return []
    })

    return recipes
  }, [])
}

export const getBasketRecipesFromBasketIDs = ({
  recipeIdsInBasket,
  recipeAvailabilities,
}: {
  recipeIdsInBasket: Record<string, number>
  recipeAvailabilities: TRecipeAvailability<TSummaryAvailabilityRecipe>[]
}): TBasketRecipeFullDetails[] => {
  return recipeAvailabilities.reduce((recipes, currentAvailability) => {
    const recipeIds = Object.keys(recipeIdsInBasket)

    recipeIds.map((recipeId: string) => {
      const hasMultipleRecipes = recipeIdsInBasket[recipeId] > 1
      if (parseInt(recipeId, 10) === currentAvailability.recipe.id) {
        return recipes.push({
          ...transformSummaryAvailabilityToRecipeWithQuantity({
            recipeAvailability: currentAvailability,
            recipesInBasket: recipeIdsInBasket,
          }),
          basketDisplayTitle: hasMultipleRecipes
            ? `${recipeIdsInBasket[recipeId]}x ${currentAvailability.recipe.title}`
            : currentAvailability.recipe.title,
        })
      }

      return []
    })

    return recipes
  }, [])
}
